// extracted by mini-css-extract-plugin
export default {"backdrop":"FeedbackModal_backdrop__oLcVv","modal-root":"FeedbackModal_modal-root__3mbhu","header":"FeedbackModal_header__+kLD5","textarea":"FeedbackModal_textarea__sMMWV"};